import script from "./Tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=2eed9fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eed9fbc"]])

export default __exports__